<template>
  <div>
    <p class="text_left">
      <strong>Note:</strong> If you want to assign a shift for a specific date,
      please select the date from the calendar.
    </p>
    <div class="text-center section">
      <v-calendar
        class="custom-calendar max-w-full"
        :masks="masks"
        :attributes="attributes"
        disable-page-swipe
        is-expanded
      >
        <template v-slot:day-content="{ day, attributes }">
          <div
            class="flex flex-col h-full z-10 overflow-hidden"
            @click="dayClicked(day)"
          >
            <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
            <div class="flex-grow overflow-y-auto overflow-x-auto">
              <p
                v-for="attr in attributes"
                :key="attr.key"
                class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                :title="
                  attr.customData.shift_name + ' / ' + attr.customData.key
                "
                @click="showData($event, attr.customData)"
              >
                <span v-if="attr.customData.shift_id">
                  {{ attr.customData.shift_name }} /
                  <span :style="{ color: attr.customData.color }">{{
                    attr.customData.key
                  }}</span>
                  <span v-if="attr.customData.is_compensatory">
                    <span
                      v-if="attr.customData.is_compensatory_credited"
                      class="credited_comp"
                      title="Compensatory approved"
                      >CS</span
                    >
                    <span
                      v-else
                      class="normal_comp"
                      title="Compensatory scheduled"
                      >CS</span
                    ></span
                  >
                </span>
                <span v-else>
                  {{ attr.customData.formatted_custom_start_time }} -
                  {{ attr.customData.formatted_custom_end_time }}
                  <span v-if="attr.customData.is_compensatory">
                    <span
                      v-if="attr.customData.is_compensatory_credited"
                      class="credited_comp"
                      title="Compensatory approved"
                      >CS</span
                    >
                    <span
                      v-else
                      class="normal_comp"
                      title="Compensatory scheduled"
                      >CS</span
                    ></span
                  >
                </span>
              </p>
            </div>
          </div>
        </template>
      </v-calendar>
      <div class="modal" :class="{ open_modal: showModal }" data-modal="modal">
        <div class="modal_overlay" data-modal-close="modal"></div>
        <div class="modal_wrap">
          <div class="modal_header">
            <div class="d_flex_btwn">
              <h3>{{ title }}</h3>
              <span>
                <span
                  data-modal-close="modal"
                  class="close_icon close_icon_md"
                  @click.prevent="closeModal"
                ></span>
              </span>
            </div>
          </div>
          <div class="modal_inner">
            <div class="modal_content modal_600p">
              <div class="row">
                <template v-if="!form.id">
                  <div class="col_6 pr_20">
                    <div
                      :class="[
                        'form_row_inline',
                        { has_error: errorFor('date') },
                      ]"
                    >
                      <label class="required">From date</label>
                      <div class="form_input">
                        <date-picker v-model:input="form.date"></date-picker>
                        <v-errors :errors="errorFor('date')"></v-errors>
                      </div>
                    </div>
                  </div>
                  <div class="col_6 pr_20">
                    <div
                      :class="[
                        'form_row_inline',
                        { has_error: errorFor('end_date') },
                      ]"
                    >
                      <label class="required">To date</label>
                      <div class="form_input">
                        <date-picker
                          v-model:input="form.end_date"
                        ></date-picker>
                        <v-errors :errors="errorFor('end_date')"></v-errors>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="col_12 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('shift_id') },
                    ]"
                  >
                    <label class="">Shift template</label>
                    <div class="form_input">
                      <select
                        class="form_global"
                        v-model="form.shift_id"
                        @change="onShiftTemplateChange"
                      >
                        <option value="">Choose shift template</option>
                        <option
                          v-for="shift in shifts"
                          :key="shift.id"
                          :value="shift.id"
                        >
                          {{ shift.name }} / {{ shift.key }}
                        </option>
                      </select>
                      <v-errors :errors="errorFor('shift_id')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('custom_start_time') },
                    ]"
                  >
                    <label class="required">Start time</label>
                    <div class="form_input">
                      <time-picker
                        v-model:input="form.custom_start_time"
                        :disabled="!!form.shift_id"
                      ></time-picker>
                      <!-- <v-errors :errors="errorFor('start_time')"></v-errors> -->
                    </div>
                  </div>
                </div>
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('custom_end_time') },
                    ]"
                  >
                    <label class="required">End time</label>
                    <div class="form_input">
                      <time-picker
                        v-model:input="form.custom_end_time"
                        :disabled="!!form.shift_id"
                      ></time-picker>
                      <!-- <v-errors :errors="errorFor('end_time')"></v-errors> -->
                    </div>
                  </div>
                </div>
                <div class="col_6 pr_20">
                  <div
                    :class="[
                      'form_row_inline',
                      { has_error: errorFor('is_compensatory') },
                    ]"
                  >
                    <label class="required">Compensatory shift</label>
                    <div class="form_checkbox d_flex_start">
                      <input
                        type="checkbox"
                        id="is_compensatory"
                        v-model="form.is_compensatory"
                        :disabled="form.is_compensatory_credited"
                      />
                      <label for="is_compensatory" class="text_nowrap pr_0">
                        <span
                          v-if="form.is_compensatory_credited"
                          class="color_green"
                          >Compensatory approved</span
                        ></label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col_6">
                  <div class="form_row_inline">
                    <label></label>
                    <div class="form_input">
                      <template v-if="form.id">
                        <button
                          class="btn btn_primary"
                          :disabled="lyLoading"
                          @click.prevent="update"
                        >
                          Update
                        </button>
                        <button
                          class="btn btn_danger ml_10"
                          :disabled="lyLoading"
                          @click.prevent="deleteRecord()"
                        >
                          Delete
                        </button>
                      </template>

                      <button
                        class="btn btn_primary"
                        :disabled="lyLoading"
                        @click.prevent="submit"
                        v-else
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import DatePicker from '@/components/shared/DatePicker';
import TimePicker from '@/components/shared/TimePicker';
export default {
  components: { DatePicker, TimePicker },
  props: {
    user_id: {
      type: Number,
      required: true,
    },
    shifts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: [],
      showModal: false,
      form: {},
      title: '',
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.axios
        .get('/assigned-shifts-for-calender/' + this.user_id)
        .then((response) => {
          this.attributes = response.data.data;
        });
    },
    dayClicked(day) {
      this.form = {
        user_id: this.user_id,
        date: moment(day.date).format('YYYY-MM-DD'),
        end_date: moment(day.date).format('YYYY-MM-DD'),
        shift_id: '',
        custom_start_time: '',
        custom_end_time: '',
      };
      this.title = 'Add shift template';
      this.showModal = true;
    },
    showData(e, data) {
      e.stopPropagation();
      this.form = { ...data };
      this.form.is_compensatory = this.form.is_compensatory ? true : false;
      this.form.is_compensatory_credited = this.form.is_compensatory_credited
        ? true
        : false;
      this.title = 'Edit shift template';
      this.showModal = true;
    },
    closeModal() {
      this.allErrors = null;
      this.form = {};
      this.showModal = false;
    },
    onShiftTemplateChange() {
      const selected = this.shifts.find(
        (shift) => shift.id === this.form.shift_id
      );
      if (selected) {
        this.form.custom_start_time = selected.start_time;
        this.form.custom_end_time = selected.end_time;
      } else {
        this.form.custom_start_time = '';
        this.form.custom_end_time = '';
      }
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/assign-shifts', formData)
        .then(() => {
          this.showSuccessMsg('Assigned successfully!');
          this.loadData();
          this.form = {};
          this.showModal = false;
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      });

      this.axios
        .post('/assign-shifts/' + this.form.id, formData)
        .then(() => {
          this.showSuccessMsg('Update Successfully!');
          this.loadData();
          this.form = {};
          this.showModal = false;
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .delete('/assign-shifts/' + this.form.id)
            .then(() => {
              this.showSuccessMsg('Data has been deleted!');
              this.loadData();
              this.form = {};
              this.showModal = false;
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors;
              this.showFailMsg(err.response.data.message);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}

::v-deep(.custom-calendar.vc-container) {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;

  border-radius: 0;
  width: 100%;
}

::v-deep(.custom-calendar.vc-container .vc-header) {
  /* background-color: #f1f5f8; */
  /* padding: 10px 0; */
  height: 48px;
  margin-top: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weeks) {
  padding: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weekday) {
  background-color: var(--weekday-bg);
  border-bottom: var(--weekday-border);
  border-top: var(--weekday-border);
  padding: 5px 0;
}

::v-deep(.custom-calendar.vc-container .vc-day) {
  padding: 0 5px 3px 5px;
  text-align: left;
  height: var(--day-height);
  min-width: var(--day-width);
  background-color: white;
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1),
::v-deep(.custom-calendar.vc-container .vc-day.weekday-7) {
  background-color: #eff8ff;
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-bottom)) {
  border-bottom: var(--day-border);
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1:not(.on-bottom)) {
  border-bottom: var(--day-border-highlight);
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-right)) {
  border-right: var(--day-border);
}

::v-deep(.custom-calendar.vc-container .vc-day-dots) {
  margin-bottom: 5px;
}

::v-deep(.custom-calendar .vc-header .vc-title-wrapper .vc-title) {
  /* opacity: 1 !important; */
  /* background: red !important; */
  /* color: red; */
  background: transparent;
}
::v-deep(.custom-calendar .vc-header .vc-title:hover) {
  opacity: 1;
}

::v-deep(.custom-calendar .vc-weeks .vc-day) {
  text-align: center;
  padding: 5px;
  min-height: 60px;
  height: auto;
}
::v-deep(.custom-calendar .bg-info) {
  background: rgba(66, 153, 225);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-success) {
  background: rgba(56, 178, 172);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-green) {
  background: #16a34a;
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .credited_comp) {
  background: #16a34a;
  margin-left: 5px;
  color: #ffffff;
  padding: 1px 5px;
}
::v-deep(.custom-calendar .normal_comp) {
  background: rgba(66, 153, 225);
  margin-left: 5px;
  color: #ffffff;
  padding: 1px 5px;
}
.color_green {
  color: #16a34a;
}
.text-danger {
  color: #dc2626;
}
.float-right {
  float: right;
  cursor: pointer;
}
</style>
